import Types from "./Types";
/* eslint-disable camelcase */

/************************************************
Get Order details
*************************************************/

const getProducts = query => {
  return { type: Types.GET_PRODUCTS, query };
};

const getProductsSuccess = products => ({
  type: Types.GET_PRODUCTS_SUCCESS,
  products
});

const getProductsFailure = error => ({
  type: Types.GET_PRODUCTS_FAILURE,
  error
});

/************************************************
Get Order details
*************************************************/

const getProductCount = query => {
  return { type: Types.GET_PRODUCT_COUNT, query };
};

const getProductCountSuccess = count => ({
  type: Types.GET_PRODUCT_COUNT_SUCCESS,
  count
});

const getProductCountFailure = error => ({
  type: Types.GET_PRODUCT_COUNT_FAILURE,
  error
});

/*** Search **/

const searchProducts = params => {
  return { type: Types.SEARCH_PRODUCTS, params };
};

const searchProductsSuccess = products => ({
  type: Types.SEARCH_PRODUCTS_SUCCESS,
  products
});

const searchProductsFailure = error => ({
  type: Types.SEARCH_PRODUCTS_FAILURE,
  error
});

/* Accept products */
const postProducts = (products: Object, params: string) => {
  return {
    type: Types.POST_PRODUCTS,
    products,
    params
  };
};

const postProductsSuccess = (products: Object, params: string) => {
  return {
    type: Types.POST_PRODUCTS_SUCCESS,
    products,
    params
  };
};

const postProductsFailure = (error: Object) => {
  return {
    type: Types.POST_PRODUCTS_FAILURE,
    error
  };
};

/* Export Offers */
const exportOffers = (offers: Object, params: string) => {
  return {
    type: Types.EXPORT_OFFERS,
    offers,
    params
  };
};

const exportOffersSuccess = (offers: Object, params: string) => {
  return {
    type: Types.EXPORT_OFFERS_SUCCESS,
    offers,
    params
  };
};

const exportOffersFailure = (error: Object) => {
  return {
    type: Types.EXPORT_OFFERS_FAILURE,
    error
  };
};

/* Export PSKUU */
const exportPSku = () => {
  return {
    type: Types.EXPORT_PSKU
  };
};

const exportPSkuSuccess = () => {
  return {
    type: Types.EXPORT_PSKU_SUCCESS
  };
};

const exportPSkuFailure = error => {
  return {
    type: Types.EXPORT_PSKU_FAILURE,
    error
  };
};

/* Accept products */
const activateOffers = (products: Object, params: string) => {
  return {
    type: Types.ACTIVATE_OFFERS,
    products,
    params
  };
};

const activateOffersSuccess = (products: Object, params: string) => {
  return {
    type: Types.ACTIVATE_OFFERS_SUCCESS,
    products,
    params
  };
};

const activateOffersFailure = (error: Object) => {
  return {
    type: Types.ACTIVATE_OFFERS_FAILURE,
    error
  };
};

/* Delete products */
const deleteOffers = (products: Object, params: string) => {
  return {
    type: Types.DELETE_OFFERS,
    products,
    params
  };
};

const deleteOffersSuccess = (products: Object, params: string) => {
  return {
    type: Types.DELETE_OFFERS_SUCCESS,
    products,
    params
  };
};

const deleteOffersFailure = (error: Object) => {
  return {
    type: Types.DELETE_OFFERS_FAILURE,
    error
  };
};

/* Import Offers */
const importOffers = (offers: Object, params: string) => {
  return {
    type: Types.IMPORT_OFFERS,
    offers,
    params
  };
};

const importOffersSuccess = (offers: Object, params: string) => {
  return {
    type: Types.IMPORT_OFFERS_SUCCESS,
    offers,
    params
  };
};

const importOffersFailure = (error: Object) => {
  return {
    type: Types.IMPORT_OFFERS_FAILURE,
    error
  };
};

/* importPSkuUnique */
const importPSkuUnique = (pSkuUnique: Object, params: string) => {
  return {
    type: Types.IMPORT_P_SKU_UNIQUE,
    pSkuUnique,
    params
  };
};

const importPSkuUniqueSuccess = (documentBatchId, params: string) => {
  return {
    type: Types.IMPORT_P_SKU_UNIQUE_SUCCESS,
    documentBatchId,
    params
  };
};

const importPSkuUniqueFailure = (error: Object) => {
  return {
    type: Types.IMPORT_P_SKU_UNIQUE_FAILURE,
    error
  };
};

export {
  getProducts,
  getProductsSuccess,
  getProductsFailure,
  searchProducts,
  searchProductsSuccess,
  searchProductsFailure,
  postProducts,
  postProductsSuccess,
  postProductsFailure,
  exportOffers,
  exportOffersSuccess,
  exportOffersFailure,
  activateOffers,
  activateOffersSuccess,
  activateOffersFailure,
  deleteOffers,
  deleteOffersSuccess,
  deleteOffersFailure,
  importOffers,
  importOffersSuccess,
  importOffersFailure,
  importPSkuUnique,
  importPSkuUniqueSuccess,
  importPSkuUniqueFailure,
  exportPSku,
  exportPSkuSuccess,
  exportPSkuFailure,
  getProductCount,
  getProductCountSuccess,
  getProductCountFailure
};



// WEBPACK FOOTER //
// ./src/actions/ProductsActions.js